module.exports = __webpack_public_path__ + "static/assets/1d5995545cb85480b175befe526bb982.jpg";